export const scrollIntoView = (actionRef) => {
  if (actionRef?.current) {
    const actionPanel = actionRef.current
    const actionNode = actionPanel.querySelectorAll('div')[0]

    if (actionNode) {
      actionNode.scrollIntoView({
        behavior: 'smooth',
        block: 'start', // Change block from 'nearest' to 'start'
        inline: 'center',
      })
    }
  } else {
    console.error('actionRef is not assigned to a DOM element')
  }
}
